<template>
  <div
    id="container"
    class="w-full flex flex-col ml-auto gap-3 lg:gap-10 px-3 lg:px-6 lg:py-6 mb-5 bg-block rounded-tl-2xl pt-3 lg:pt-7 lg:pb-28 lg:top-20 relative sm:mt-0 lg:h-screen lg:overflow-scroll h-full"
  >
    <NetworkError v-if="isConnectedToInvalidNetwork" />
    <SectionRow>
      <DashboardStats />
    </SectionRow>
    <SectionRow>
      <div
        class="flex flex-col md:flex-row items-start gap-3 lg:gap-5 w-full"
      >
        <TokenPriceChart />
        <PlatformRevenueChart />
        <!-- <MyLoanChart /> -->
      </div>
    </SectionRow>
    <SectionRow
      :title="`${showAllLoans ? 'All' : 'My'} Loans`"
      has-border
    >
      <template #action>
        <div class="flex items-center gap-3">
          <a
            style="cursor: pointer; white-space: nowrap"
            @click="showAllLoans = !showAllLoans"
          >
            <small> Show all loans </small>
          </a>
          <Toggle v-model="showAllLoans" />
          <Button
            v-if="loanCollateralTokens.length > 0"
            text="New Loan"
            secondary
            small
            full
            @click="triggerModal"
          />
        </div>
      </template>
      <div
        v-if="loanList.length > 0"
        class="grid grid-cols-1 xl:grid-cols-2 3xl:grid-cols-3 gap-5"
      >
        <LoanBlock
          v-for="(loan, index) in loanList"
          :key="index"
          :loan="loan"
        />
      </div>
      <Empty v-else title="You have no open loans yet!" />
    </SectionRow>
  </div>
  <LoanModal v-if="openLoanModal" @close="openLoanModal = false" />
</template>

<script>
import { mapGetters } from "vuex";
import SectionRow from "../components/global/SectionRow";
import LoanBlock from "../components/loan/LoanBlock";
import PlatformRevenueChart from "../components/charts/PlatformRevenueChart.vue";
import MyLoanChart from "../components/charts/MyLoanChart.vue";
import Empty from "../components/global/Empty.vue";
import NetworkError from "../components/network/NetworkError.vue";
import TokenPriceChart from "../components/charts/TokenPriceChart.vue";
import DashboardStats from "../components/dashboard/DashboardStats.vue";
import Toggle from "../components/global/Toggle.vue";
import Button from "../components/global/Button.vue";
import LoanModal from "../components/loan/LoanModal.vue";
export default {
  components: {
    SectionRow,
    LoanBlock,
    PlatformRevenueChart,
    MyLoanChart,
    Empty,
    NetworkError,
    TokenPriceChart,
    DashboardStats,
    Toggle,
    Button,
    LoanModal,
  },
  data() {
    return {
      showAllLoans: false,
      openLoanModal: false,
    };
  },

  computed: {
    ...mapGetters([
      "activeNetwork",
      "isConnected",
      "isOnValidNetwork",
      "loanCollateralTokens",
      "allFormattedLoans",
      "userOwnedLoans",
    ]),

    isConnectedToInvalidNetwork() {
      return this.isConnected && !this.isOnValidNetwork;
    },

    loanList() {
      return this.showAllLoans
        ? this.allFormattedLoans
        : this.userOwnedLoans;
    },
  },

  methods: {
    triggerModal() {
      this.$store.commit(
        "SET_SELECTED_COLLATERAL_POOL",
        this.activeNetwork.contracts.mainLp
      );
      this.openLoanModal = true;
    },
  },
};
</script>
